// store.js
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from '@/utils/baseApi';
import aesKeyReducer from './api/aesKeySlice';

const store = configureStore({
  reducer: {
    // Your static reducers
    aesKey: aesKeyReducer,

    // Add the baseApi reducer under the specified reducerPath ('api')
    [baseApi.reducerPath]: baseApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore RTK Query's action types
        ignoredActions: [
          'api/executeQuery/pending',
          'api/executeQuery/fulfilled',
          'api/executeQuery/rejected'
        ],
        ignoredPaths: ['payload.timestamp']
      },
      immutableCheck: true
    }).concat(
      baseApi.middleware
    ),
  devTools: process.env.NODE_ENV !== 'production'
});

// Enable refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export default store;